// extracted by mini-css-extract-plugin
var _1 = "AssigneeField-moduleassigneeFieldTags__QQSOF FormFieldSelectNG-moduleformFieldMultiSelectTags__U0s9Y SelectValueTags-moduleSelectValueTags__hO7SX TagBar-moduleTagBar__a7w7V";
export { _1 as "assigneeFieldTags" }
